interface ComputerWithRocketSVGProps {
  color: string;
  style: React.CSSProperties;
}

const ComputerWithRocketSVG = ({
  color,
  style,
}: ComputerWithRocketSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="45"
    height="57"
    viewBox="0 0 45 57"
    fill="none"
  >
    <g clipPath="url(#clip0_678_13111)">
      <path
        d="M29.5195 7.82999H32.2795"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.2796 7.83001H39.8796C41.6096 7.83001 43.0096 9.23001 43.0096 10.96V35.85C43.0096 37.58 41.6096 38.97 39.8796 38.97H4.17957C2.44957 38.97 1.05957 37.57 1.05957 35.85V10.95C1.05957 9.22001 2.45957 7.82001 4.17957 7.82001H15.5496"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3297 38.97L9.42969 43.79H22.0297H34.6397L32.7297 38.97"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.67 47.45L43.32 54.04C43.87 55.03 43.15 56.25 42.02 56.25H2.05003C0.920027 56.25 0.200027 55.03 0.750027 54.04L4.40003 47.45H39.68H39.67Z"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.87 24.38L18.25 22.78C13.37 9.82 22.54 0.779999 22.54 0.779999C22.54 0.779999 30.25 8.38 27.76 19.64C27.53 20.65 27.23 21.7 26.82 22.77L26.21 24.37"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M17.2298 19.23C13.2998 23.16 16.8398 28.52 16.8398 28.52L17.2698 28.09C18.6598 26.7 20.5498 25.91 22.5298 25.91C24.4998 25.91 26.3898 26.69 27.7898 28.09L28.2198 28.52C28.2198 28.52 31.7598 23.16 27.8398 19.23"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M25.1395 14.68C25.1395 16.12 23.9795 17.28 22.5395 17.28C21.0995 17.28 19.9395 16.12 19.9395 14.68C19.9395 13.24 21.0995 12.08 22.5395 12.08C23.9795 12.08 25.1395 13.24 25.1395 14.68Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M25.8202 5.57001C24.9102 6.28001 23.7702 6.71001 22.5302 6.71001C21.2902 6.71001 20.1602 6.29001 19.2402 5.57001"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M20.2998 29.64C20.3098 34.47 22.5398 35.65 22.5398 35.65C22.5398 35.65 24.7698 34.47 24.7798 29.64"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M22.5498 28.17V30.92"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_678_13111">
        <rect width="44.07" height="56.8" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default ComputerWithRocketSVG;
